import React from "react";

const SearchInput = ({ onChange, placeholder }) => {
  return (
    <div className="relative w-full">
      {/* Search icon */}
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>

      {/* Search input */}
      <input
        type="text"
        className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200 text-gray-800 placeholder-gray-400"
        onChange={onChange}
        placeholder={placeholder}
      />

      {/* Small text for mobile - can be visible only on small screens if needed */}
      {/* <div className="text-xs text-gray-500 mt-1 hidden sm:block">
        Search by name, code, location or branch
      </div> */}
    </div>
  );
};

export default SearchInput;
